import TableJs from './Table'
import Utils from './utils'
export default {
    TableJs,
    Utils
}